var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrillaVaciaResumenIngreso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 200,
    viewBox: "0 0 157 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.646 143.997C142.646 177.134 115.783 199.997 82.6464 199.997C49.5096 199.997 18.647 175.997 18.647 123.998C18.647 71.9987 94.6462 0 110.646 0C116.525 0 94.9066 32.1292 98.6462 63.9989C102.195 94.2459 142.646 109.909 142.646 143.997Z",
    fill: "#2D72B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4152 153.801C19.0614 160.301 13.3906 145.847 13.3906 133.681C13.3906 119.256 24.6933 106.582 41.7444 99.3438",
    stroke: "#B9D1EB",
    strokeWidth: 25.1725
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.634 160.993C129.988 169.341 140.084 162.653 143.127 148.407C146.171 134.161 134.689 103.809 111.869 95.9062",
    stroke: "#B9D1EB",
    strokeWidth: 25.1725
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0957 109.387C44.0957 94.501 56.1632 82.4336 71.0491 82.4336H92.6602C107.546 82.4336 119.614 94.5011 119.614 109.387V183.677H44.0957V109.387Z",
    fill: "#B9D1EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.7358,
    y: 26.5566,
    width: 36.2375,
    height: 46.1956,
    rx: 18.1188,
    fill: "#B9D1EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4819,
    y: 47.8545,
    width: 20.7467,
    height: 45.3657,
    rx: 10.3733,
    fill: "#B9D1EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9817 81.2802L82.1319 116.181L102.386 81.0996C120.842 83.3731 134.213 91.9788 142.67 105.061L121.53 118.727C120.949 117.829 120.314 116.951 119.615 116.103V183.677H44.0966V112.236C39.431 114.5 35.5345 117.209 32.5813 120.138L14.8545 102.266C26.2182 90.9951 43.167 83.6012 61.9817 81.2802Z",
    fill: "#719FDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.722 112.882L121.671 118.734C121.089 117.835 120.454 116.957 119.754 116.109V188.791C109.566 195.951 96.7313 200 82.7858 200C68.8182 200 55.2546 195.736 44.2362 186.908V112.244C39.5709 114.507 35.6747 117.217 32.7217 120.146L20.8579 108.185C22.0285 103.454 23.6619 98.6422 25.6716 93.8079C35.9133 87.2879 48.5305 82.9642 62.1214 81.2875L82.2712 116.188L102.526 81.1064C103.436 81.2186 104.335 81.3462 105.221 81.489C109.242 88.0511 114.62 94.1107 120.047 100.226C123.718 104.362 127.411 108.523 130.722 112.882Z",
    fill: "#719FDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.963 82.4336L82.131 126.14L54.6071 82.4336",
    stroke: "#003C73",
    strokeOpacity: 0.1,
    strokeWidth: 1.10649
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3906 133.683C13.3906 145.849 19.0614 160.303 47.4152 153.803",
    stroke: "#B9D1EB",
    strokeWidth: 25.1725
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7357 26.001H99.9732L101.91 41.7683H61.7993L63.7357 26.001Z",
    fill: "#719FDB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3977 24.0654H98.0355L100.527 42.0458H62.9062L65.3977 24.0654Z",
    fill: "#719FDB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2669 82.709C56.2669 81.9451 55.6477 81.3259 54.8838 81.3259C54.1199 81.3259 53.5007 81.9451 53.5007 82.709L56.2669 82.709ZM53.5007 82.709L53.5007 108.988L56.2669 108.988L56.2669 82.709L53.5007 82.709Z",
    fill: "#003C73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5757 107.606C50.305 107.606 46.0322 111.879 46.0322 117.15V133.747C46.0322 138.034 48.8595 141.662 52.7513 142.866C53.5708 143.119 54.3309 142.45 54.3309 141.592C54.3309 140.907 53.835 140.335 53.1939 140.094C50.6259 139.13 48.7985 136.652 48.7985 133.747V117.15C48.7985 113.407 51.8327 110.373 55.5757 110.373C59.3187 110.373 62.353 113.407 62.353 117.15V133.747C62.353 136.652 60.5255 139.13 57.9575 140.094C57.3164 140.335 56.8205 140.907 56.8205 141.592C56.8205 142.45 57.5806 143.119 58.4001 142.866C62.2919 141.662 65.1192 138.034 65.1192 133.747V117.15C65.1192 111.879 60.8464 107.606 55.5757 107.606Z",
    fill: "#003C73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1187 124.479H62.3525V133.745C62.3525 136.65 60.525 139.128 57.957 140.092C57.3159 140.333 56.82 140.905 56.82 141.59C56.82 142.448 57.5801 143.117 58.3996 142.864C62.2914 141.66 65.1187 138.033 65.1187 133.745V124.479ZM48.798 124.479H46.0317V133.745C46.0317 138.033 48.859 141.66 52.7509 142.864C53.5703 143.117 54.3304 142.448 54.3304 141.59C54.3304 140.905 53.8345 140.333 53.1934 140.092C50.6254 139.128 48.798 136.65 48.798 133.745V124.479Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1648 142.114C60.5006 141.929 60.694 141.568 60.694 141.185C60.694 140.149 59.2492 139.535 58.3 139.952C58.1877 140.001 58.0738 140.047 57.9585 140.091C57.3173 140.331 56.8215 140.904 56.8215 141.588C56.8215 142.446 57.5816 143.116 58.401 142.862C59.018 142.671 59.6083 142.42 60.1648 142.114ZM52.8531 139.951C51.9039 139.534 50.459 140.148 50.459 141.185C50.459 141.568 50.6524 141.929 50.9882 142.114C51.5448 142.419 52.1352 142.671 52.7523 142.862C53.5718 143.116 54.3319 142.446 54.3319 141.588C54.3319 140.904 53.836 140.331 53.1949 140.091C53.0794 140.047 52.9654 140.001 52.8531 139.951Z",
    fill: "#B9D1EB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.103,
    cy: 115.35,
    rx: 6.91556,
    ry: 6.91551,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.101,
    cy: 115.351,
    rx: 4.42596,
    ry: 4.42593,
    fill: "#003C73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.102 82.709L109.102 115.35",
    stroke: "#003C73",
    strokeWidth: 2.76621,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 27.4737,
    height: 25.0248,
    rx: 12.5124,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 27.9717 144.986)",
    fill: "#B9D1EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 39.3455,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 32.9087 143.977)",
    fill: "#B9D1EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 39.3455,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 23.8896 152.207)",
    fill: "#B9D1EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 39.3455,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 26.1367 158.133)",
    fill: "#B9D1EB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 25.1563,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 38.9722 161.895)",
    fill: "#B9D1EB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73.417,
    y: 123.926,
    width: 40.9401,
    height: 57.9826,
    rx: 5.53243,
    fill: "#0063BE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98.6108,
    y: 129.114,
    width: 13.1527,
    height: 4.6312,
    rx: 2.3156,
    fill: "black"
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 24.0163,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.962889 -0.269906 0.269909 -0.962884 112.31 176.816)",
    fill: "#B9D1EB"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 34.9348,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.922013 -0.387162 0.387167 -0.922009 118.905 174.752)",
    fill: "#B9D1EB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 24.1948,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.902417 -0.430865 0.43087 -0.902413 113.232 165.996)",
    fill: "#B9D1EB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 25.1563,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.866027 -0.499997 0.500003 -0.866024 119.823 163.221)",
    fill: "#B9D1EB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 113.804,
    y: 169.545,
    width: 25.1562,
    height: 6.25624,
    rx: 3.12811,
    transform: "rotate(-89.0674 113.804 169.545)",
    fill: "#B9D1EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.127 148.488C140.78 159.473 134.24 165.964 118.369 164.533C116.517 164.366 114.537 164.091 112.422 163.703",
    stroke: "#B9D1EB",
    strokeWidth: 25.1725
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrillaVaciaResumenIngreso);
export default __webpack_public_path__ + "static/media/grilla-vacia-resumen-ingreso.c16ab30a666a9e441ca3da62ac1485a3.svg";
export { ForwardRef as ReactComponent };